export const ARROW_HEAD_TYPES = {
  TRIANGLE: 'triangle',
  OPEN_TRIANGLE: 'openTriangle',
};

export const ARROW_HEAD_TYPE = ARROW_HEAD_TYPES.TRIANGLE;

const HEAD_LENGTH_RATIO = 0.13;
const OPEN_TRIANGLE_HEAD_LENGTH_RATIO = 1.35;
const MIN_HEAD_LENGTH_AT_ZOOM1 = 0.12; // zoom=1 기준 최소 화살촉 길이(% 단위)
const MAX_HEAD_LENGTH_AT_ZOOM1 = 1.0;  // zoom=1 기준 최대 화살촉 길이(% 단위)
const ARROW_HEAD_ANGLE = Math.PI / 6;

export function getArrowHeadGeometry({
  x1,
  y1,
  x2,
  y2,
  zoomLevel = 1,
  aspectRatio = 1,
}) {
  const dx = (x2 - x1) * aspectRatio;
  const dy = y2 - y1;

  if (dx === 0 && dy === 0) {
    return {
      lineEndX: x2,
      lineEndY: y2,
      pathD: `M${x2},${y2} L${x2},${y2} L${x2},${y2}`,
    };
  }

  const angle = Math.atan2(dy, dx);

  const arrowLength = Math.sqrt(dx * dx + dy * dy);
  const zoomScale = 1 / Math.sqrt(zoomLevel);
  const minHeadLength = MIN_HEAD_LENGTH_AT_ZOOM1 * zoomScale;
  const maxHeadLength = MAX_HEAD_LENGTH_AT_ZOOM1 * zoomScale;
  const baseHeadLength = Math.max(
    Math.min(minHeadLength, arrowLength),
    Math.min(maxHeadLength, arrowLength * HEAD_LENGTH_RATIO),
  );
  const rawHeadLength = ARROW_HEAD_TYPE === ARROW_HEAD_TYPES.OPEN_TRIANGLE
    ? baseHeadLength * OPEN_TRIANGLE_HEAD_LENGTH_RATIO
    : baseHeadLength;
  const headLength = Math.min(rawHeadLength, arrowLength);

  const arrowTip1X = x2 - (headLength * Math.cos(angle - ARROW_HEAD_ANGLE)) / aspectRatio;
  const arrowTip1Y = y2 - headLength * Math.sin(angle - ARROW_HEAD_ANGLE);
  const arrowTip2X = x2 - (headLength * Math.cos(angle + ARROW_HEAD_ANGLE)) / aspectRatio;
  const arrowTip2Y = y2 - headLength * Math.sin(angle + ARROW_HEAD_ANGLE);

  if (ARROW_HEAD_TYPE === ARROW_HEAD_TYPES.TRIANGLE) {
    const baseX = (arrowTip1X + arrowTip2X) / 2;
    const baseY = (arrowTip1Y + arrowTip2Y) / 2;

    return {
      lineEndX: baseX,
      lineEndY: baseY,
      pathD: `M${x2},${y2} L${arrowTip1X},${arrowTip1Y} L${arrowTip2X},${arrowTip2Y} Z`,
    };
  }

  return {
    lineEndX: x2,
    lineEndY: y2,
    pathD: `M${arrowTip1X},${arrowTip1Y} L${x2},${y2} L${arrowTip2X},${arrowTip2Y}`,
  };
}